export default __webpack_public_path__ + "static/thunder-blacklc-dd9a68eaad40993fcdbb72446fc33426.woff2";